import { isIosWebKit } from "../utils/isIosWebKit";

/**
 * Firebase Auth tries IndexedDB first. On iOS Safari that `indexedDB.open`
 * often never fires success or error, so `onAuthStateChanged` never runs and
 * the shell stays on the boot spinner. Android IndexedDB settles, so the same
 * build loads there.
 *
 * iOS must not list IndexedDB at all: Auth still awaits every persistence in
 * the hierarchy while looking for a saved user.
 * @returns {boolean}
 */
export function useLocalStorageAuthPersistence() {
  return isIosWebKit();
}
